// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

/**
 * Whole-years age from a date-of-birth string (the `date` field stores a native
 * `YYYY-MM-DD` value) to today, formatted for a collapsed card summary:
 * "2 Years Old" / "1 Year Old" / "Less than 1 Year Old". Returns an empty string
 * for a missing/unparseable value so callers can omit the part.
 */
export function formatAge(dob: unknown): string {
  if (typeof dob !== 'string' || dob.trim() === '') return '';
  const birth = new Date(dob);
  if (Number.isNaN(birth.getTime())) return '';

  const now = new Date();
  let years = now.getFullYear() - birth.getFullYear();
  // Subtract a year if the birthday hasn't occurred yet this year.
  const monthDiff = now.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
    years -= 1;
  }

  if (years < 0) return '';
  if (years < 1) return 'Less than 1 Year Old';
  return `${years} ${years === 1 ? 'Year' : 'Years'} Old`;
}
